// announcement bar
$(".announce_slider").owlCarousel({
  items: 1,
  loop: true,
  nav: false,
  dots: false,
  autoplay:true,
  autoplayTimeout:8000
});

// top slider
$(".slider_carousel").owlCarousel({
  items: 1,
  loop: false,
  nav: false,
  dots: false,
  autoplay:true,
  autoplayTimeout:8000 
});

$("#accessories-product").owlCarousel({
  items: 4,
  loop: true,
  nav: false,
  dots: false,
  margin: 15,
  autoplayTimeout:4500,
  smartSpeed:1000,
  responsive:{
      0:{
          items:1,
          margin: 10,
          stagePadding:50
      },
      400:{
          items:1,
          stagePadding:90
      },
      451:{
        items:2,
        stagePadding:70
      },
      576:{
        items:3,
        stagePadding:0
      },
      992:{
          items:4
      }
  }
});

// $("#collection-slider").owlCarousel({
//   items: 3,
//   loop: true,
//   nav: true,
//   dots: false,
//   autoplay:true,
//   autoplayTimeout:8000,
//   autoplayHoverPause:true,
//   smartSpeed:1000,
//   navText: ['<svg width="24" height="43" viewBox="0 0 24 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.021 1.99084L1.021 21.9908L22.021 41.9908" stroke="#414042" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="24" height="43" viewBox="0 0 24 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.021 1.99084L22.021 21.9908L1.021 41.9908" stroke="#414042" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
//   responsive:{
//       0:{
//           items:1,
//           stagePadding:40
//       },
//       451:{
//         items:1,
//         nav: false,
//         stagePadding:70
//       },
//       576:{
//         items:2,
//         nav: true,
//         stagePadding:0
//       },
//       992:{
//           items:3
//       }
//   }
// });

$("#product-slider-wrapper").owlCarousel({
  items: 2,
  loop: true,
  nav: true,
  dots: false,
  autoplay:true,
  navText: ['<svg width="80" height="72" viewBox="0 0 80 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.5909 0.841933L0.480467 35.9523L35.5909 71.0627L45.8243 60.8293L28.1027 43.1909L79.5203 43.1909L79.5203 28.7144L28.1027 28.7144L45.8243 11.076L35.5909 0.841933Z" fill="#D1BAA9"/></svg>','<svg width="80" height="72" viewBox="0 0 80 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.4091 71.1578L79.5195 36.0474L44.4091 0.93701L34.1757 11.1705L51.8973 28.8089L0.479674 28.8089L0.479673 43.2854L51.8973 43.2854L34.1757 60.9238L44.4091 71.1578Z" fill="#D1BAA9"/></svg>'],
  autoplayTimeout:5000,
  smartSpeed:1000,
  responsive:{
      0:{
          items:1
      },
      400:{
        items:2
      }
  }
});

  setTimeout(function () {
    $("#product_recommendations_slider").owlCarousel({
      items: 4,
      loop: true,
      nav: false,
      dots: false,
      margin: 30,
      autoplay:true,
      autoplayTimeout:5000,
      smartSpeed:1000,
      responsive:{
          0:{
            items:1,
            stagePadding:40
          },
          400:{
            items:1,
            stagePadding:70
          },
          451:{
            items:2,
            stagePadding:0
          },
          768:{
            items:3
          },
          1200:{
            items:4
          }
      }
    });
  }, 3000);


$("#collection-featured-slider").owlCarousel({
  items: 4,
  loop: true,
  dots: false,
  autoplay:false,
  autoplayTimeout:3500,
  smartSpeed:1000,
  autoplay:false,
  autoplayHoverPause:true,
  navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1206" data-name="Path 1206" d="M53.5,56.763a2.713,2.713,0,0,0,1.913-4.626L40.039,36.762,55.414,21.388a2.708,2.708,0,0,0-3.827-3.834L34.292,34.849a2.707,2.707,0,0,0,0,3.827L51.587,55.97a2.688,2.688,0,0,0,1.913.792Z" transform="translate(-33.5 -16.763)" fill="#fff"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1205" data-name="Path 1205" d="M36.208,56.763a2.713,2.713,0,0,1-1.913-4.626L49.669,36.762,34.295,21.388a2.708,2.708,0,0,1,3.827-3.834L55.416,34.849a2.707,2.707,0,0,1,0,3.827L38.121,55.97a2.688,2.688,0,0,1-1.913.792Z" transform="translate(-33.5 -16.763)" fill="#fff"/></svg>'],
  responsive:{
      0:{
          items:1,
          stagePadding:40
      },
      451:{
        items:1,
        stagePadding:70
      },
      576:{
        items:2,
        stagePadding: 0,
        nav:true
      },
        768:{
          items:3
      },
      992:{
          items:4
      }
  }
});



// Show the first tab by default
$('.tabify-section-wrapper .tabs-stage .container div').hide();
$('.tabify-section-wrapper .tabs-stage .container div:first').show();
$('.tabify-section-wrapper .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.tabify-section-wrapper .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabify-section-wrapper .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabify-section-wrapper .tabs-stage .container .tabify-description').hide();
  $($(this).attr('href')).show();
  $($(this).attr('href')).show().children('div').show().children('div').show();
});

// $('.hero_content a.main_btn').on('click', function(event){
//   $('html, body').animate({
//       scrollTop: $("#fetured_collection_self").offset().top
//   }, 2000);
// });


function isNumberKey(evt){
 var charCode = (evt.which) ? evt.which : evt.keyCode
 if (charCode > 31 && (charCode < 48 || charCode > 57))
   return false;
 return true;
}